export default __webpack_public_path__ + "static/media/Group9269.bf701d0a.svg";